import React from 'react';
import classNames from 'classnames/bind';
import { Button, Cell, SkeletonBrick } from '@carnica/ui-kit';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { useIsDesktopDimension } from '@beef/elk-common/hooks';
import { GroupContent } from '@beef/elk-common';
import { Metric } from "../../../../../utils/metric";
import { selectFubGroupsCount, selectFubGroupsError, selectFubGroupsLoading, selectFubMembers, selectFubMembersCount, selectFubStatus } from "../../store/selectors";
import { getGroupTitleBlock, getIsStatusEnabled, getItems } from "../../utils";
import styles from "./styles.pcss";
import { selectBaseUrl, selectUserType } from "../../../../../store/selectors";
import { UNIFIED_PRODUCT_DEEP_LINK, fubTexts } from "../../constants";
import { Card } from "../../../Card";
var cn = classNames.bind(styles);
export var SKELETON_SIZE = {
  height: {
    desktop: 20,
    mobile: 20
  },
  width: {
    desktop: 120,
    mobile: 96
  }
};
var _GroupBanner = function _GroupBanner(_ref) {
  var fubMembersCount = _ref.fubMembersCount,
    fubGroupsCount = _ref.fubGroupsCount,
    fubStatus = _ref.fubStatus,
    isLoading = _ref.isLoading,
    userType = _ref.userType,
    isError = _ref.isError,
    baseUrl = _ref.baseUrl,
    members = _ref.members;
  var isDesktop = useIsDesktopDimension();
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Cell, {
      className: cn('cell'),
      leftSide: function leftSide() {
        return /*#__PURE__*/React.createElement("div", {
          className: cn('wrapper')
        }, /*#__PURE__*/React.createElement(SkeletonBrick, {
          height: SKELETON_SIZE.height,
          width: SKELETON_SIZE.width
        }));
      },
      "data-t-id": "components-GroupBanner"
    });
  }
  var handleBannerClick = function handleBannerClick(e) {
    if (isDesktop) {
      e.preventDefault();
      window.location.href = "".concat(baseUrl, "?type=ub");
    }
  };
  var titleBlock = isError ? {
    title: fubTexts.membersBannerTitle.error,
    subTitle: ''
  } : getGroupTitleBlock(fubStatus, fubMembersCount, fubGroupsCount);
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      userType: userType,
      title: titleBlock === null || titleBlock === void 0 ? void 0 : titleBlock.title,
      fubStatus: fubStatus,
      fubMembersCount: fubMembersCount
    }),
    events: {
      fubMetricSideMenu: ['handleGroupClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('wrap'),
    href: UNIFIED_PRODUCT_DEEP_LINK,
    mode: "inline",
    onClick: handleBannerClick,
    tagName: "a",
    "data-t-id": "components-GroupBanner"
  }, /*#__PURE__*/React.createElement(Card, {
    className: cn('extended'),
    color: "primary",
    size: "xl",
    "data-t-id": "components-GroupBanner"
  }, /*#__PURE__*/React.createElement(GroupContent, {
    avatarImage: fubTexts.avatar.default,
    isError: isError,
    items: getItems(members),
    status: fubStatus,
    subTitle: titleBlock.subTitle,
    title: titleBlock.title,
    "data-t-id": "components-GroupBanner"
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  var isError = selectFubGroupsError(state);
  var fubStatus = selectFubStatus(state);
  var isLoading = selectFubGroupsLoading(state);
  return {
    fubGroupsCount: selectFubGroupsCount(state),
    fubMembersCount: selectFubMembersCount(state),
    fubStatus: fubStatus,
    isLoading: isLoading,
    userType: selectUserType(state),
    isError: isError,
    baseUrl: selectBaseUrl(state),
    shouldRender: getIsStatusEnabled(fubStatus) || isError || isLoading,
    members: selectFubMembers(state)
  };
};
var connector = connect(mapStateToProps);
export var GroupBanner = compose(connector, withRenderFlag)(_GroupBanner);